export default "__VITE_ASSET__3d664db2__"